import { Tracker } from '@pegasus/tracker';
import { CampaignEarlyAccessState, EarlyAccessPhase } from './types';
export var tracker = new Tracker();
export var getEarlyAccessTrackingPhase = function (_a) {
    var earlyAccessState = _a.earlyAccessState, earlyAccessPhase = _a.earlyAccessPhase;
    switch (earlyAccessState) {
        case CampaignEarlyAccessState.Active:
            return 'earlyAccess';
        case CampaignEarlyAccessState.Expired:
            return 'generalAccess';
        default:
            break;
    }
    switch (earlyAccessPhase) {
        case EarlyAccessPhase.BuildUp:
            return 'buildUp';
        case EarlyAccessPhase.PreEarlyAccess:
            return 'preEarlyAccess';
        case EarlyAccessPhase.EarlyAccess:
            return 'earlyAccess';
        case EarlyAccessPhase.GeneralAccess:
            return 'generalAccess';
        default:
            break;
    }
    return null;
};
